<p-dialog
  header="Розпізнати контакт з тексту"
  [(visible)]="visible"
  [modal]="true"
  [closable]="true"
  [style]="{'width': '600px'}"
  (onHide)="visible = false">

  <!-- Parse input phase: textarea + button -->
  <div *ngIf="!parsed; else quickCreatePhase" class="agent-paste-to-create">
    <div class="field mb-3">
      <label for="pastedText" class="block">Вставте текст (підпис, контакт, тощо):</label>
      <textarea
        id="pastedText"
        [(ngModel)]="pastedText"
        [disabled]="loading"
        rows="8"
        class="w-full"
        pInputTextarea>
      </textarea>
    </div>

    <p-progressSpinner
      *ngIf="loading"
      styleClass="mb-3"
      strokeWidth="6">
    </p-progressSpinner>

    <div *ngIf="!loading && error" class="p-error mb-3">
      {{ error }}
    </div>
  </div>

  <!-- Quick create phase: embed AgentCustomerQuickCreateComponent -->
  <ng-template #quickCreatePhase>
    <app-agent-customer-quick-create
      [mode]="mode"
      [cliId]="cliId"
      [extractedSignals]="getIdentitySignals()"
      [senderEmail]="getSenderEmail()"
      [addressPostalCode]="getAddressPostalCode()"
      [addressCountry]="getAddressCountry()"
      [addressCity]="getAddressCity()"
      [addressStreet]="getAddressStreet()"
      (created)="onCreated($event)">
    </app-agent-customer-quick-create>
  </ng-template>

  <!-- Footer must be a direct child of p-dialog -- PrimeNG's content-projection for
       pTemplate="footer" only recognizes it there, not nested inside another element
       (confirmed live: nesting it inside the *ngIf div above silently dropped it).
       The template itself stays unconditional (a *ngIf directly on a pTemplate
       ng-template is an unverified edge case, not worth risking here); the buttons
       inside are gated instead -- once parsed, AgentCustomerQuickCreateComponent has
       its own save/cancel controls, so no dialog-level footer buttons are needed. -->
  <ng-template pTemplate="footer">
    <ng-container *ngIf="!parsed">
      <p-button
        label="Скасувати"
        [text]="true"
        severity="secondary"
        (onClick)="visible = false">
      </p-button>
      <p-button
        label="Розпізнати"
        icon="pi pi-search"
        [loading]="loading"
        [disabled]="!pastedText.trim() || loading"
        (onClick)="onExtract()">
      </p-button>
    </ng-container>
  </ng-template>

</p-dialog>
